import { Navigate, useRoutes } from 'react-router-dom';
import DashboardLayout from './layouts/dashboard';
import SimpleLayout from './layouts/simple';
import LoginPage from './pages/LoginPage';
import SignUpPage from './pages/SignUpPage';
import Page404 from './pages/Page404';
import SensorConfiguration from './pages/SensorConfiguration';
import DashboardAppPage from './pages/DashboardAppPage';
import DeviceManagement from './pages/SensorManagement';
import SensorDetails from './pages/SensorDetails';
import VstSettings from './pages/VstSettings';
import RecordingConfiguration from './pages/RecordSettings';
import NvStreamerDashboard from './pages/nvstreamer/NvStreamerDashboard';
import NvStreamerConfiguration from './pages/nvstreamer/NvStreamerConfiguration';
import NvStreamerManagement from './pages/nvstreamer/NvStreamerManagement';

const STREAMER_ROUTES = [
  {
    path: `/${window.adaptorType}`,
    element: <DashboardLayout />,
    children: [
      { element: <Navigate to={`/${window.adaptorType}/dashboard`} />, index: true },
      { path: 'dashboard', element: <NvStreamerDashboard /> },
      { path: 'configuration', element: <NvStreamerConfiguration /> },
      { path: 'management', element: <NvStreamerManagement /> },
      { path: 'streams', element: <></> },
      { path: 'file-upload', element: <></> },
      { path: `settings`, element: <VstSettings /> },
      { path: 'debug', element: <></> },
    ],
  },
  {
    path: 'login',
    element: <LoginPage />,
  },
  {
    path: 'signup',
    element: <SignUpPage />,
  },
  {
    element: <SimpleLayout />,
    children: [
      { element: <Navigate to={`/${window.adaptorType}/dashboard`} />, index: true },
      { path: '404', element: <Page404 /> },
      { path: '*', element: <Navigate to="/404" /> },
    ],
  },
  {
    path: '*',
    element: <Navigate to="/404" replace />,
  },
];

const MMS_ROUTES = [
  {
    path: `/${window.adaptorType}`,
    element: <DashboardLayout />,
    children: [
      { element: <Navigate to={`/${window.adaptorType}/dashboard`} />, index: true },
      { path: 'dashboard', element: <DashboardAppPage /> },
      { path: 'sensor-management', element: <DeviceManagement /> },
      { path: 'record-settings', element: <RecordingConfiguration /> },
      { path: 'sensor-details', element: <SensorDetails /> },
      { path: 'live-streams', element: <></> },
      { path: 'recorded-streams', element: <></> },
      { path: 'video-wall', element: <></> },
      { path: `settings`, element: <VstSettings /> },
      { path: 'debug', element: <></> },
    ],
  },
  {
    path: 'login',
    element: <LoginPage />,
  },
  {
    path: 'signup',
    element: <SignUpPage />,
  },
  {
    element: <SimpleLayout />,
    children: [
      { element: <Navigate to={`/${window.adaptorType}/dashboard`} />, index: true },
      { path: '404', element: <Page404 /> },
      { path: '*', element: <Navigate to="/404" /> },
    ],
  },
  {
    path: '*',
    element: <Navigate to="/404" replace />,
  },
];

const DEFAULT_ROUTES = [
  {
    path: `/${window.adaptorType}`,
    element: <DashboardLayout />,
    children: [
      { element: <Navigate to={`/${window.adaptorType}/dashboard`} />, index: true },
      { path: 'dashboard', element: <DashboardAppPage /> },
      { path: 'sensor-management', element: <DeviceManagement /> },
      { path: 'sensor-configuration', element: <SensorConfiguration /> },
      { path: 'record-settings', element: <RecordingConfiguration /> },
      { path: 'sensor-details', element: <SensorDetails /> },
      { path: 'live-streams', element: <></> },
      { path: 'recorded-streams', element: <></> },
      { path: 'video-wall', element: <></> },
      { path: `settings`, element: <VstSettings /> },
      { path: 'debug', element: <></> },
    ],
  },
  {
    path: 'login',
    element: <LoginPage />,
  },
  {
    path: 'signup',
    element: <SignUpPage />,
  },
  {
    element: <SimpleLayout />,
    children: [
      { element: <Navigate to={`/${window.adaptorType}/dashboard`} />, index: true },
      { path: '404', element: <Page404 /> },
      { path: '*', element: <Navigate to="/404" /> },
    ],
  },
  {
    path: '*',
    element: <Navigate to="/404" replace />,
  },
];

export default function Router() {
  const { adaptorType } = window;
  let routesArr = [];
  switch (adaptorType) {
    case 'streamer':
      routesArr = STREAMER_ROUTES;
      break;
    case 'mms':
      routesArr = MMS_ROUTES;
      break;
    default:
      routesArr = DEFAULT_ROUTES;
      break;
  }

  const routes = useRoutes(routesArr);

  return routes;
}
